import https from './http.js';

	//设置个对象，就不用一个个暴露了，直接暴露对象
	let apiFun = {};
	/* 获取列表 */
	//查询列表，详情就是get
	/* /api/getlist是请求接口地址，有http.js里面的Ip加上，如：http:192.168.0.1:9090//api/getlist  */
	apiFun.getHomePage = function(params) {
		return https.get('/getHomePage', params)
	}
	apiFun.getFilmById = function(params) {
		return https.get('/getFilmById', params)
	}
	apiFun.getTvById = function(params) {
		return https.get('/getTvById', params)
	}
	apiFun.getschoolInfo = function(params) {
		return https.post('/getschoolinfo', params)
	}
	apiFun.getFilmList = function(params) {
		return https.post('/getFilm', params)
	}
	apiFun.getSearchList = function(params) {
		return https.post('/searchVideo', params)
	}
	apiFun.getTvList = function(params) {
		return https.post('/getTv', params)
	}
	apiFun.register = function(params) {
		return https.post('/u_register', params)
	}
	apiFun.login = function(params) {
		return https.post('/u_login', params)
	}
	apiFun.buy = function(params) {
		return https.post('/u_buy', params)
	}
	apiFun.queryBuy = function(params) {
		return https.post('/q_buy', params)
	}
	apiFun.getArticleList = function(params) {
		return https.get('/getArticleList', params)
	}
	apiFun.getArticleById = function(params) {
		return https.get('/getArticleById', params)
	}
	apiFun.queryOrderStatus = function(params) {
		return https.post('/q_order_status', params)
	}

	//暴露出这个对象
	export default apiFun;


// WEBPACK FOOTER //
// ./src/api/api.js